

module.exports = (resource) => {
  if (
    resource &&
    resource.sys &&
    resource.sys.type &&
    resource.sys.linkType &&
    resource.sys.id &&
    resource.sys.type === 'Link'
  ) {
    return false;
  }

  return true;
};
